import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [{
		path: "/login",
		name: 'login',
		component: () => import('@/views/login/index'),
	},
	{
		path: "/indexmodule",
		name: 'indexmodule',
		props({
			query
		}) {
			let cleanedQuery = Object.keys(query).reduce((acc, key) => {
				let newKey = key.replace(/amp;/g, ''); // 移除所有 'amp;' 字符
				acc[newKey] = query[key];
				return acc;
			}, {});
			return {
				moduleConfig: {
					name: cleanedQuery.name,
					moduleName: cleanedQuery.moduleName,
					foreingKey: cleanedQuery.foreingKey ? JSON.parse(decodeURIComponent(cleanedQuery.foreingKey)) : {},
					device: cleanedQuery.device ? cleanedQuery.device : window.systemMethods.device(),
				}

			}
		},
		component: () => import('@_system/components/module/index.vue'),
	},
	{
		path: "/add",
		name: 'add',
		props({
			query
		}) {
			let cleanedQuery = Object.keys(query).reduce((acc, key) => {
				let newKey = key.replace(/amp;/g, ''); // 移除所有 'amp;' 字符
				acc[newKey] = query[key];
				return acc;
			}, {});
			return {
				formConfig: {
					id: cleanedQuery.id,
					name: cleanedQuery.name,
					controlltype: cleanedQuery.controlltype,
					foreingKey: cleanedQuery.foreingKey ? JSON.parse(decodeURIComponent(cleanedQuery.foreingKey)) : {},
					extra: cleanedQuery.extra ? JSON.parse(decodeURIComponent(cleanedQuery.extra)) : {},
					windowName: cleanedQuery.windowName,
					moduletype: cleanedQuery.moduletype,
					windowType: 'window',
					isflow: cleanedQuery.isflow ? cleanedQuery.isflow : 0,
					flowprogressid: cleanedQuery.flowprogressid ? cleanedQuery.flowprogressid : 0,
					flowid: cleanedQuery.flowid ? cleanedQuery.flowid : 0,
					device: cleanedQuery.device ? cleanedQuery.device : window.systemMethods.device(),
				}

			}
		},
		component: () => import('@_system/components/forms/window/formwindow.vue'),
	},
	{
		path: "/update",
		name: 'update',
		props({
			query
		}) {
			let cleanedQuery = Object.keys(query).reduce((acc, key) => {
				let newKey = key.replace(/amp;/g, ''); // 移除所有 'amp;' 字符
				acc[newKey] = query[key];
				return acc;
			}, {});
			return {
				formConfig: {
					id: cleanedQuery.id,
					name: cleanedQuery.name,
					controlltype: cleanedQuery.controlltype,
					foreingKey: cleanedQuery.foreingKey ? JSON.parse(decodeURIComponent(cleanedQuery.foreingKey)) : {},
					extra: cleanedQuery.extra ? JSON.parse(decodeURIComponent(cleanedQuery.extra)) : {},
					windowName: cleanedQuery.windowName,
					moduletype: cleanedQuery.moduletype,
					windowType: 'window',
					isflow: cleanedQuery.isflow ? cleanedQuery.isflow : 0,
					flowprogressid: cleanedQuery.flowprogressid ? cleanedQuery.flowprogressid : 0,
					flowid: cleanedQuery.flowid ? cleanedQuery.flowid : 0,
					device: cleanedQuery.device ? cleanedQuery.device : window.systemMethods.device(),
				}

			}
		},
		component: () => import('@_system/components/forms/window/formwindow.vue'),
	},
	{
		path: "/preview",
		name: 'preview',
		props({
			query
		}) {
			let cleanedQuery = Object.keys(query).reduce((acc, key) => {
				let newKey = key.replace(/amp;/g, ''); // 移除所有 'amp;' 字符
				acc[newKey] = query[key];
				return acc;
			}, {});
			return {
				formConfig: {
					id: cleanedQuery.id,
					name: cleanedQuery.name,
					controlltype: cleanedQuery.controlltype,
					foreingKey: cleanedQuery.foreingKey ? JSON.parse(decodeURIComponent(cleanedQuery.foreingKey)) : {},
					extra: cleanedQuery.extra ? JSON.parse(decodeURIComponent(cleanedQuery.extra)) : {},
					windowName: cleanedQuery.windowName,
					moduletype: cleanedQuery.moduletype,
					windowType: 'window',
					isflow: cleanedQuery.isflow ? cleanedQuery.isflow : 0,
					flowprogressid: cleanedQuery.flowprogressid ? cleanedQuery.flowprogressid : 0,
					flowid: cleanedQuery.flowid ? cleanedQuery.flowid : 0,
					device: cleanedQuery.device ? cleanedQuery.device : window.systemMethods.device(),
				}

			}
		},
		component: () => import('@_system/components/forms/window/formwindow.vue'),
	},
	{
		path: "/report",
		name: 'report',
		props({
			query
		}) {
			let cleanedQuery = Object.keys(query).reduce((acc, key) => {
				let newKey = key.replace(/amp;/g, ''); // 移除所有 'amp;' 字符
				acc[newKey] = query[key];
				return acc;
			}, {});
			return {
				reportConfig: {
					name: cleanedQuery.name,
					reportName: cleanedQuery.reportName,
					device: cleanedQuery.device ? cleanedQuery.device : window.systemMethods.device(),
				}

			}
		},
		component: () => import('@_system/components/reports/index.vue'),
	},
	{
		path: "/penetrate",
		name: 'penetrate',
		props({
			query
		}) {
			let cleanedQuery = Object.keys(query).reduce((acc, key) => {
				let newKey = key.replace(/amp;/g, ''); // 移除所有 'amp;' 字符
				acc[newKey] = query[key];
				return acc;
			}, {});
			return {
				penetrateConfig: {
					id: cleanedQuery.id,
					name: cleanedQuery.name,
					title: cleanedQuery.title,
				}

			}
		},
		component: () => import('@_system/components/penetrate/index.vue'),
	},
	{
		path: "/custompage",
		name: 'custompage',
		props({
			query
		}) {
			let cleanedQuery = Object.keys(query).reduce((acc, key) => {
				let newKey = key.replace(/amp;/g, ''); // 移除所有 'amp;' 字符
				acc[newKey] = query[key];
				return acc;
			}, {});
			console.log({
					id: cleanedQuery.id,
					name: cleanedQuery.name,
					title: cleanedQuery.title,
					extra: cleanedQuery.extra ? JSON.parse(decodeURIComponent(cleanedQuery.extra)) : {},
				},123123)
			return {
				custompageConfig: {
					id: cleanedQuery.id,
					name: cleanedQuery.name,
					title: cleanedQuery.title,
					extra: cleanedQuery.extra ? JSON.parse(decodeURIComponent(cleanedQuery.extra)) : {},
				}
	
			}
		},
		component: () => import('@_system/components/custompage/index.vue'),
	},
	// {
	// 	path: "*",
	// 	redirect: "/login"
	// }
	// {
	// 	path: "/demo2",
	// 	name: 'demo2',
	// 	component: () => import('@/views/main/demo2'),
	// 	meta: {
	// 		index: '1-2'
	// 	}
	// },

]


const router = new VueRouter({
	//mode: 'history',
	routes
})
router.afterEach((to) => {
	let reg = /^\/main/
	if (reg.test(to.path) && router.app.$store) {
		router.app.$store.commit('main/activeTabs', {
			path: to.path
		})
	}

})
router.beforeEach((to, from, next) => {
	//window.console.log(to, from)
	//to.meta.keepAlive = true
	next()
})

export default router